<div [class]="class" fxLayout="row" [routerLink]="link!=null ? link : null" role="button">
    <div fxLayoutAlign="center center"><mat-icon class="icon image-responsive">{{ icon }}</mat-icon></div>
    <div fxLayoutAlign="start center" class="text" [innerHtml]="text"></div>
</div>
